import { Card } from "@/components/ui/card";
import { Brain, Shield, Users, TrendingUp } from "lucide-react";

const features = [
  {
    icon: Brain,
    title: "AI-Powered Resume Builder",
    description: "Transform your life experiences into professional qualifications with intelligent guidance and ROA-compliant criminal history support.",
    color: "text-secondary",
  },
  {
    icon: Shield,
    title: "Progressive Disclosure",
    description: "Share your story on your terms. Criminal record information is only shared when there's mutual interest, protecting your privacy.",
    color: "text-accent",
  },
  {
    icon: Users,
    title: "Skills-First Matching",
    description: "Our algorithm prioritizes your skills, potential, and fit—not your past. Connect with employers who value what you can contribute.",
    color: "text-secondary",
  },
  {
    icon: TrendingUp,
    title: "Comprehensive Support",
    description: "Interview preparation, UK employment practice training, and ongoing support from probation officers and community organisations.",
    color: "text-accent",
  },
];

export const Features = () => {
  return (
    <section className="py-32 bg-gradient-to-br from-background via-muted/20 to-background relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,_hsl(var(--primary)/0.08),transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_70%,_hsl(var(--accent)/0.08),transparent_50%)]" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-20 space-y-6">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-primary/10 backdrop-blur-sm rounded-full text-primary font-semibold border border-primary/20 mb-4">
            <span className="w-2 h-2 bg-accent rounded-full"></span>
            <span>Evidence-Based Features</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold leading-tight">
            Built for <span className="text-primary">Success</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Comprehensive tools designed to break down barriers and create meaningful employment opportunities.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <Card
              key={index}
              className="p-10 hover:shadow-[var(--shadow-elevated)] transition-all duration-300 hover:-translate-y-2 border-2 hover:border-primary/30 bg-card/80 backdrop-blur-sm group"
            >
              <div className="p-4 bg-primary/10 rounded-2xl w-fit mb-6 group-hover:scale-110 transition-transform group-hover:bg-accent/10">
                <feature.icon className="w-12 h-12 text-accent" />
              </div>
              <h3 className="text-2xl font-bold mb-4">{feature.title}</h3>
              <p className="text-muted-foreground leading-relaxed text-lg">{feature.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
